import * as types from './types'
import * as integrations from '../../../integration'
import * as menu from '../menu'

export const receiveProfile = (payload) => ({
  type: types.RECEIVE_PROFILE,
  payload
})

export const reveiveRoles = (payload) => ({
  type: types.RECEIVE_ROLES,
  payload
})

export const receiveDashboards = (payload) => ({
  type: types.RECEIVE_DASHBOARDS,
  payload
})

export const receiveBusinessCode = (payload) => ({
  type: types.RECEIVE_BUSSINES_CODE,
  payload
})

export const clearAll = () => ({
  type: types.CLEAR_ALL
})

export const fetch = (payload = true) => ({
  type: types.FETCH_PROFILE,
  payload
})

export const receiveTerms = (payload) => ({
  type: types.RECEIVE_TERMS,
  payload
})

export const fetchProfile = () => async (dispatch) => {
  dispatch(fetch())

  try {
    const data =
      await integrations.resources.profile.requests.getProfileResource()

    dispatch(
      receiveProfile({
        name: data.name,
        profileImageUrl: data.profileImageUrl
      })
    )
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err)
  } finally {
    dispatch(fetch(false))
  }
}

export const fetchInitialData = () => [
  menu.actions.getSidebarMenu(),
  fetchProfile()
]
